import { useState } from "react";
import ListPage from "../../../customUiForCs/ListPage";
import UserActivityCard from "./UserActivityCard";
import DropDownInput from "../../../helperComponents/DropDownInput";

let actionTypes = [
  { label: "Créer", value: "CREATE" },
  { label: "Mettre à jour", value: "UPDATE" },
  { label: "Voir", value: "VIEW" },
  { label: "Supprimer", value: "DELETE" },
];

let subjectTypes = [
  { label: "Site", value: "SITE" },
  { label: "Zone", value: "ZONE" },
  { label: "Profile", value: "PROFILE" },
  { label: "Role", value: "ROLE" },
  { label: "Comment", value: "COMMENT" },
  { label: "Absence", value: "ABSENCE" },
  { label: "Vacation", value: "VACATION" },
  { label: "Contentieux", value: "DISPUTE" },
];

export default function UserActivitiesListPage() {
  const [subjectType, setSubjectType] = useState(null);
  const [actionType, setActionType] = useState(null);

  return (
    <ListPage
      filters={
        <>
          <DropDownInput
            options={actionTypes}
            onChange={setActionType}
            value={actionType}
            label="Action"
          />
          <DropDownInput
            options={subjectTypes}
            onChange={setSubjectType}
            value={subjectType}
            label="Taper"
          />
        </>
      }
      queryParams={{ subjectType, actionType }}
      titleLine1={"Activités récentes "}
      titleLine2={"Des utilisateurs"}
      path="user-activities"
      CardComponent={UserActivityCard}
      permissionName={"activitiesPermissions"}
    />
  );
}
